module.exports = __webpack_public_path__ + "img/personinfo.5c74ec04.png";